<script>
	import { onMount } from "svelte";
	import Navbar from "./components/donorflow-ui/Navbar.svelte";
	import Router, { location, querystring, push } from "svelte-spa-router";
	import { parse } from "qs";
	import Quizzes from "./routes/Quizzes.svelte";
	import New from "./routes/New.svelte";
	import Login from "./routes/Login.svelte";
	import NotFound from "./routes/NotFound.svelte";
	import Cookies from "js-cookie";
	import { firebaseConfig, authAPI } from "./config";
	import Quiz from "./routes/Quiz.svelte";

	export let dftCookie;
	export let dftUrl;

	let db;
	let user;
	let authed = false;

	const routes = {
		"/": Quizzes,
		"/quiz/:id": Quiz,
		"/new": New,
		"/login": Login,
		"*": NotFound,
	};

	async function logIntoFs(ct) {
		firebase
			.auth()
			.signInWithCustomToken(ct)
			.then((userCredential) => {
				// Signed in
				user = userCredential.user;
				console.log(user);
				authed = true;
				// ...
			})
			.catch((error) => {
				var errorCode = error.code;
				var errorMessage = error.message;
				// ...
			});
	}
	async function getFsCustomToken(jwtToken) {
		return fetch(authAPI + "/signintofs?token=" + jwtToken)
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				setCookies(data.d);
				return data;
			});
	}

	async function setCookies(d) {
		Cookies.set("dfusername", d[0]);
		localStorage.setItem("lportal", d[1]);
		localStorage.setItem("portal", d[2]);
	}

	async function doAuthFlow(dft) {
		user = firebase.auth().currentUser;
		if (!user) {
			getFsCustomToken(dft)
				.then(async (retTok) => {
					await logIntoFs(retTok.token);
				})
				.catch((e) => {
					console.log(e);
				});
		}
		db = firebase.firestore();
	}

	onMount(async () => {
		if (!firebase.apps.length) {
			firebase.initializeApp(firebaseConfig);
		}
		if (!dftCookie) {
			// If no cookie token, then use token in URL:
			if (dftUrl) {
				Cookies.set("dft", dftUrl);
				await doAuthFlow(dftUrl);
				authed = true;
			} else {
				push("/login");
			}
		} else {
			doAuthFlow(dftCookie).then(() => authed = true);
		}
	});
</script>

{#if $location !== "/login" && authed}
	<Navbar
		showSecondary={true}
		secondaryNavItems={[
			{ label: "Quizes", path: "/" },
			{ label: "Responses", path: "/responses" },
		]}
	/>
{/if}
<Router {routes} />

<style>
</style>
